import vuexStore from '@/vuex-store';
import { pStore } from '@/pinia';
/**
 * 미들웨어 매뉴얼
 * 미들웨어간에는 next에 인자가 없으면 다음 미들웨어로 진행된다.
 * 미들웨어에 인자가 존재하면 vue router를 실행한다.
 * next()는 특이사항이 없음으로 다음 미들웨어를 호출한다는 의미이다.
 * next(xxx)등 인자가 존재한다면 특정 이벤트를 호출한다는 의미로 context.next가 실행된다.
 *
 * 장점
 * 미들웨어를 하나의 그룹으로 묶을 수 있고
 * 반대로 중간에 login페이지로 가는 등의 액션을 취할 때는 인자를 입력해서 제어할 수 있다.
 * 인증과 같은 미들웨어는 순서에 상관 없이 중간에 끊어줘야 한다 그럴 때 사용한다.
 * hubSelector처럼 끊어주지 않아도 될 땐 next()를 이용해서 다음 미들웨어를 단순 호출 할 수도 있다.
 *
 * 되도록 페이지 권한과 같은 중요도 있는 미들웨어를 앞에 위치시키면 좋고
 * 중간에 있더라도 인자를 잘 넘기면 괜찮다.
 *
 * 추가 문의 윤태건 tg0825
 */
/**
 * @param {*} context
 * @param {*} middleware
 * @param {*} index
 * @returns {function}
 */
const nextFactory = (context, middleware, index) => {
    const subsequentMiddleware = middleware[index];
    // 현 미들웨어 없으면 이전 미들웨어 리턴
    if (!subsequentMiddleware) {
        return context.next;
    }
    // 미들웨어에서 실행할 next 생성
    return (...parameters) => {
        // TODO vue router next 실행 (현재 우리 구조에서는 실행 필요 x. 최종적으로만 실행되면 됨.) 히스토리를 위한 주석
        if (parameters.length) {
            context.next(...parameters);
        }
        // 다음 next 생성
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        // 이전 next 생성시 클로져로 물고 있던 미들웨어 실행
        subsequentMiddleware({
            ...context,
            next: nextMiddleware,
        });
    };
};
const routerEnhancer = (to, from, next) => {
    if (from) {
        pStore.piniaGlobal.urlHistory = from.name;
    }
    // TODO: 개선 필요. meta의 기본값이 object이기 때문에 에러 핸들링 해줘야 함.
    // 함수 아니고 객체 비어있을 경우
    if (typeof to.meta !== 'function' && !Object.keys(to.meta).length) {
        return next();
    }
    // const hasMetaMiddleware = to.meta(to)?.middleware;
    const hasMetaMiddleware = to.meta?.middleware;
    if (hasMetaMiddleware) {
        const middleware = Array.isArray(hasMetaMiddleware)
            ? hasMetaMiddleware
            : [
                hasMetaMiddleware,
            ];
        const context = {
            to,
            from,
            next,
            store: vuexStore,
            pStore,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({
            ...context,
            next: nextMiddleware,
        });
    }
    return next();
};
export default routerEnhancer;
